import { adminTypes } from "@admin/admin-types.di";
import type { AdminRepository } from "@admin/domain/repositories/admin.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { inject, injectable } from "inversify";

@injectable()
export class SpatialLevelDeleteUseCase {
    constructor(
        @inject(adminTypes.repositories.AdminRepository)
        private readonly adminRepository: AdminRepository,
    ) {}
    async execute(stationId: string, spatialLevelId: string): Promise<boolean> {
        const result = await this.adminRepository.deleteSpatialLevel(
            stationId,
            spatialLevelId,
        );

        if (result.isErr()) {
            ToastManagerRepository.error(result.error.message);
        }

        return result.isOk();
    }
}
